import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MANAGE_GROUPS, type Feature, type ManageGroup } from './features';

const KEY = 'routeback:rail-open';
const load = (): ManageGroup[] => { try { return JSON.parse(localStorage.getItem(KEY) ?? '[]') as ManageGroup[]; } catch { return []; } };

/**
 * The desktop sidebar's manager tools, folded into five groups. The group
 * holding the open screen is always expanded; others open on a click and
 * stay open (remembered per browser).
 */
export function RailGroups({ items }: { items: Feature[] }) {
  const loc = useLocation();
  const [open, setOpen] = useState<ManageGroup[]>(load);
  const current = items.find((f) => f.to && (loc.pathname === f.to || loc.pathname.startsWith(f.to + '/')))?.group;
  useEffect(() => { try { localStorage.setItem(KEY, JSON.stringify(open)); } catch { /* private mode */ } }, [open]);
  const toggle = (g: ManageGroup) => setOpen((o) => (o.includes(g) ? o.filter((x) => x !== g) : [...o, g]));
  return (
    <>
      <div className="rail-section"><NavLink to="/manage" end className={({ isActive }) => 'rail-section-link' + (isActive ? ' active' : '')}>Manage</NavLink></div>
      {MANAGE_GROUPS.map((g) => {
        const list = items.filter((f) => f.group === g.id);
        if (!list.length) return null;
        const isOpen = open.includes(g.id) || current === g.id;
        return (
          <div key={g.id} className={'rail-group' + (current === g.id ? ' has-active' : '')}>
            <button type="button" className="rail-group-head" aria-expanded={isOpen} onClick={() => toggle(g.id)}>
              <span>{g.icon}</span><span className="grow">{g.label}</span><span className="rail-caret" aria-hidden>{isOpen ? '▾' : '▸'}</span>
            </button>
            {isOpen && list.map((f) => (
              <NavLink key={f.id} to={f.to!} className={({ isActive }) => 'rail-sub' + (isActive ? ' active' : '')}><span>{f.icon}</span>{f.label}</NavLink>
            ))}
          </div>
        );
      })}
    </>
  );
}
